import { render, staticRenderFns } from "./account-create-fx-alert.vue?vue&type=template&id=ce46bbd2&"
import script from "./account-create-fx-alert.vue?vue&type=script&lang=js&"
export * from "./account-create-fx-alert.vue?vue&type=script&lang=js&"
import style0 from "./account-create-fx-alert.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports